export default __webpack_public_path__ + "static/media/bg6.f88c2fcd.png";